const UPDATES = [
  { id: 'u1', time: '2 分钟前', text: '某艺人工作室发布正式声明，否认近期网络传闻，称将通过法律途径维权。', tag: '最新' },
  { id: 'u2', time: '15 分钟前', text: '热搜第一持续霸榜：某知名博主被曝光私生活混乱，当事人暂未回应。', tag: '热搜' },
  { id: 'u3', time: '28 分钟前', text: '新综艺首播收视率创纪录，参演嘉宾表现引发全网热议，评论区炸了。', tag: '热门' },
  { id: 'u4', time: '45 分钟前', text: '某品牌代言人事件迎来反转：品牌方连夜发布道歉声明，承认沟通失误。', tag: '反转' },
  { id: 'u5', time: '1 小时前', text: '百万大V被实名举报抄袭，原创作者公开证据链，平台已介入调查。', tag: '争议' },
  { id: 'u6', time: '1.5 小时前', text: '某地突发社会事件引发全网关注，多家媒体跟进报道，官方已启动调查程序。', tag: '社会' },
  { id: 'u7', time: '2 小时前', text: '科技圈新动态：某独角兽企业被传估值腰斩，创始人内部信曝光。', tag: '科技' },
  { id: 'u8', time: '3 小时前', text: '海外娱乐圈重磅消息：某好莱坞巨星被曝婚变，外媒纷纷跟进报道。', tag: '海外' },
  { id: 'u9', time: '4 小时前', text: '直播带货新规落地首日：多名头部主播直播间销售额断崖式下滑。', tag: '行业' },
];

const TAG_COLORS: Record<string, string> = {
  '最新': 'bg-primary-100 text-primary-700',
  '热搜': 'bg-accent-100 text-accent-700',
  '热门': 'bg-accent-100 text-accent-700',
  '反转': 'bg-secondary-100 text-secondary-700',
  '争议': 'bg-accent-100 text-accent-700',
  '社会': 'bg-primary-100 text-primary-700',
  '科技': 'bg-secondary-100 text-secondary-700',
  '海外': 'bg-secondary-100 text-secondary-700',
  '行业': 'bg-primary-100 text-primary-700',
};

export default function Updates() {
  return (
    <section id="updates" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">
          最新快讯
        </h2>
        <p className="text-sm text-foreground-600 text-center mb-10">
          实时更新的热门事件动态时间线
        </p>
        <div className="relative">
          <div className="absolute left-5 top-0 bottom-0 w-0.5 bg-background-200/80 hidden md:block"></div>
          <div className="space-y-2">
            {UPDATES.map((item) => (
              <div key={item.id} className="flex gap-4 items-start pl-0 md:pl-0">
                <div className="hidden md:flex w-10 flex-shrink-0 justify-center relative">
                  <div className="w-3 h-3 rounded-full bg-primary-400 mt-1.5 relative z-10"></div>
                </div>
                <div className="flex-1 bg-background-100 rounded-xl p-4 border border-background-200/60 hover:border-primary-200 transition-all cursor-pointer">
                  <div className="flex items-center gap-2 mb-1.5 flex-wrap">
                    <span className={`text-xs font-medium px-2 py-0.5 rounded-full whitespace-nowrap ${TAG_COLORS[item.tag] || 'bg-secondary-100 text-secondary-700'}`}>
                      {item.tag}
                    </span>
                    <span className="text-xs text-foreground-500">{item.time}</span>
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed">{item.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}